<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Uma empresa global</h2>
          <p>
            A JBS adquire a <strong>Primo SmallGoods</strong>, empresa líder no
            mercado australiano. Um avanço significativo na agregação de valor e
            desenvolvimento de marcas fortes na Austrália e na Nova Zelândia.
          </p>
          <p>
            Já a compra da <strong>Moy Park</strong>, na Irlanda, marca o avanço
            da construção da plataforma de produção e distribuição de produtos
            preparados da JBS na Europa. Nos EUA, a aquisição da operação de
            suínos da <strong>Cargill</strong>
            posiciona a JBS como a segunda maior processadora de suínos no
            mercado americano.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2015/2015-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2015/07/02/g/20150702-44452-spo-30-eco-b12-not-pqegshh.jpg'
              )
            "
            class="fistItem"
          />

          <img
            src="../assets/img/2015/2015-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2015/06/24/g/20150624-44444-nac-29-eco-b9-not-kxghhhh.jpg'
              )
            "
            class="fistItem"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
          <img
            src="../assets/img/2015/2015-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2014/05/29/g/20140529-44053-nac-67-gui-d4-not-hpkesqh.jpg'
              )
            "
            class="fistItem"
          />

          <p>
            <img src="../assets/img/link.svg" alt="" />
            <strong>leia as matérias no portal</strong>
          </p>
          <ul>
            <li>
              <a
                href="https://www.estadao.com.br/economia/radar-imobiliario/sem-paredes-para-aumentar-a-convivencia/"
                target="_blank"
                >Imóveis novos priorizam espaços sociais amplos e integrados</a
              >
            </li>
            <li>
              <a
                href="https://www.estadao.com.br/economia/radar-imobiliario/uso-da-varanda-gourmet-requer-bom-senso/"
                target="_blank"
                >Uso da varanda gourmet requer bom senso</a
              >
            </li>
            <li>
              <a
                href="https://www.estadao.com.br/economia/radar-imobiliario/varanda-pode-facilitar-venda-ou-locacao/"
                target="_blank"
                >Varanda pode facilitar venda ou locação</a
              >
            </li>
          </ul>
        </div>
        <div class="formato__warpper__item--black">
          <h2>Comida em casa: varandas gourmet e cozinhas integradas</h2>
          <p>
            Nos anos 2010, preparar refeições inteiras e receber as pessoas em
            casa ganhou novos significados com a popularização de duas novidades
            da arquitetura: as <strong>varandas gourmet</strong>, com
            churrasqueiras e espaços para grandes mesas, e as cozinhas
            integradas, unindo o local de preparação (a cozinha) com o da
            refeição (a sala de jantar). As novidades influenciaram o mercado
            imobiliário, mostrando outro sinal de como as pessoas buscavam
            resgatar a preparação de alimentos em casa. O
            <strong>Estadão</strong> registrou, por exemplo, o interesse dos
            consumidores de assar em casa um frango assado parecido com o que se
            compra em padarias e açougues.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 508px 300px 226px;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 20px;
      }
      &--image {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        @include media("<=desktop") {
          padding: 20px;
        }
        .fistItem {
          margin-top: -20px;
        }
        img {
          &:nth-child(2) {
            margin-top: -70px;
            margin-right: auto;
            margin-bottom: -20px;
          }
        }
        p {
          img {
            display: block;
          }
          display: block;
          font-size: 0.75rem;
          font-style: normal;
          font-weight: 400;
          font-family: font(primary);
          max-width: 103px;
          margin-right: auto;
          margin-top: -45px;
          @include media("<=desktop") {
            padding: 0 20px;
          }
          strong {
            font-weight: 400;
            background: color(cGreen);
            color: color(cWhite);
          }
        }
        ul {
          max-width: 220px;
          margin-right: auto;
          @include media("<=desktop") {
            max-width: 100%;
            padding: 0 20px;
          }
          li {
            transition: 0.3s ease-in-out;
            border-radius: 15px;
            &:hover {
              background: color(cBLue6);
            }
            a {
              display: block;
              color: color(cText);
              font-family: font(primary);
              font-size: 0.6875rem;
              font-style: normal;
              font-weight: 700;
              margin-bottom: 5px;
              padding: 10px;
              transition: 1s ease-in-out;
              text-decoration: none;
              margin-bottom: -5px;

              &:hover {
                color: color(primary);
              }
            }
          }
        }
        span {
          position: absolute;
          left: 0;
          top: 350px;
          width: 65px;
          color: color(primary);
          @include media("<=desktop") {
            left: 30px;
          }
          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(primary);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media("<=desktop") {
          padding: 40px 20px;
          background: color(cBlue7);
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue);

          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-bottom: 100px;
          @include media("<=desktop") {
            margin: 0;
          }
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue7);
      width: 38%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
